export default __webpack_public_path__ + "static/media/CorporateManagementLogo.bbf29ac8.svg";